export enum MasterAccountApplicationMethodTypeEnum {
	UNKNOWN = "UNKNOWN",
	BY_SIGNATURE = "BY_SIGNATURE",
	BY_DOCUMENTS = "BY_DOCUMENTS",
	BY_EMPLOYEE = "BY_EMPLOYEE"
}
